// // import { Route, Routes } from "react-router-dom";
// // import LiveMonitoring from "../module/LiveMonitoring/Component/liveMonitoring";
// // import Notifications from "../module/Notifications/Component/notification";
// // import AssetWiseList from "../module/LiveMonitoring/Component/assetWiseList";
// // import Dashboard from "../../BasicComponent/Components/underConstruction";

// // function AMSRoutes() {
// //   return (
// //     <Routes>
// //       <Route path="live-monitoring" element={<AssetWiseList />} />
// //       <Route path="live-monitoring/:uuid" element={<LiveMonitoring />} />
// //       {/* <Route path="notifications/*" element={<Notifications />} /> */}
// //       <Route path="notifications/*" element={<Dashboard />} />
// //     </Routes>
// //   );
// // }

// // export default AMSRoutes;

// import { Route, Routes } from "react-router-dom";
// import LiveMonitoring from "../module/LiveMonitoring/Component/liveMonitoring";
// import Notifications from "../module/Notifications/Component/notification";
// import AssetWiseList from "../module/LiveMonitoring/Component/assetWiseList";
// import Dashboard from "../../BasicComponent/Components/underConstruction";
// import ProtectedRoute from "../../components/ProtectedRoute";

// function AMSRoutes() {
//   return (
//     <Routes>
//       <Route
//         path="live-monitoring"
//         element={
//           <ProtectedRoute menuKey="AMS_LIVE_MONITORING">
//             <AssetWiseList />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="live-monitoring/:uuid"
//         element={
//           <ProtectedRoute menuKey="AMS_LIVE_MONITORING">
//             <LiveMonitoring />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="notifications/*"
//         element={
//           <ProtectedRoute menuKey="AMS_NOTIFICATIONS">
//             <Dashboard />
//           </ProtectedRoute>
//         }
//       />
//     </Routes>
//   );
// }

// export default AMSRoutes;

import { Route, Routes } from "react-router-dom";
import LiveMonitoring from "../module/LiveMonitoring/Component/liveMonitoring";
import AssetWiseList from "../module/LiveMonitoring/Component/assetWiseList";
import Dashboard from "../../BasicComponent/Components/underConstruction";
import ProtectedRoute from "../../components/ProtectedRoute";
import WriteControlScreen from "../module/writecontrole/component/WriteControlScreen";

function AMSRoutes() {
  return (
    <Routes>
      {/* Live monitoring (read) */}
      <Route
        path="live-monitoring"
        element={
          <ProtectedRoute menuKey="AMS_LIVE_MONITORING">
            <AssetWiseList />
          </ProtectedRoute>
        }
      />
      <Route
        path="live-monitoring/:uuid"
        element={
          <ProtectedRoute menuKey="AMS_LIVE_MONITORING">
            <LiveMonitoring />
          </ProtectedRoute>
        }
      />

      {/* Write control (write operations) */}
      <Route
        path="write-control/:uuid"
        element={
          <ProtectedRoute menuKey="AMS_WRITE_CONTROL">
            <WriteControlScreen />
          </ProtectedRoute>
        }
      />

      {/* Notifications */}
      <Route
        path="notifications/*"
        element={
          <ProtectedRoute menuKey="AMS_NOTIFICATIONS">
            <Dashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AMSRoutes;